import type { RouteLocationRaw } from 'vue-router'

export function replaceWithResolvedRoute (router: any, location: RouteLocationRaw): Promise<unknown> {
  return new Promise((resolve, reject) => {
    router.replace(location, () => resolve(router.currentRoute.value), reject)
  })
}
